module.exports = __webpack_public_path__ + "static/media/blue-star.fda400a0.svg";